export default "__VITE_ASSET__61223e06__"